// extracted by mini-css-extract-plugin
export default {"wrapper":"ATlXyERtYf1ifmaq0Ref","content":"duzuJlFjojq6RJ7vvodA","icon":"qtfHw3LSdAmjRsNySvbe","label":"qUOPL1RwLkC18cess9Qz"};